// frontend/src/app/utils/_apiInstance.ts
import axios from "axios";
import { EXTERNAL_LOGIN_URL } from "../consts";

const getStoredToken = () => localStorage.getItem("token") || null;

export const apiInstancePublic = axios.create({
  baseURL: "/api/lex/produto/v1/",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const apiInstance = axios.create({
  baseURL: "/api/lex/produto/v1/",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

apiInstance.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = EXTERNAL_LOGIN_URL;
    }
    return Promise.reject(error);
  }
);
